module.exports = __webpack_public_path__ + "static/media/btn_plus.7b7f6fd5.svg";